import { ApiBase } from '../api-base'

export class UserServices extends ApiBase {
  constructor() {
    super({
      resource: '/api/v1/users',
      name: 'user',
      successPath: '/'
    })
  }

  /**
   * @param {Object} param
   * @param {Object} param.user
   * @param {string} param.user.email
   * @param {string} param.user.password
   * @returns {Promise<object>}
   *
   */

  index({ q, page = '', byRole = null, status = null }) {
    const params = {}

    if (q) {
      params.q = q
    }

    if (status) {
      params.active = status
    }

    if (page) {
      params.page = page
    }

    if (byRole) {
      params.role = byRole
    }

    return this.api.get(
      `${this.resource}?` + new URLSearchParams(params).toString()
    )
  }

  signIn({ body }) {
    return this.api.post('/users/sign_in', body)
      .then(response => {
        if (response.data.redirect_to) {
          window.location.href = response.data.redirect_to;
        }
        return response;
      });
  }
  currentUser() {
    return this.api.get('/users/current')
  }

  signOut() {
    return this.api.delete('/users/sign_out')
  }
}
